var map = {
	"./Digital_icon.png": 3724,
	"./Load_icon.png": 6906,
	"./Logo.png": 6607,
	"./SMS_icon.png": 8750,
	"./account.png": 3420,
	"./admin_avatar.jpg": 4131,
	"./campaigns.png": 2001,
	"./contact.png": 8410,
	"./faq.png": 573,
	"./landing-page-background-image.png": 5123,
	"./logout.png": 6919,
	"./saved.png": 9932,
	"./send.png": 8052,
	"./topup.png": 3046,
	"./welcome.png": 3513
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;